import { AnalysisMarkdown, AnalysisSubHeader } from '../../../components';
import { useTranslation } from 'react-i18next';

interface TopBusinessChallengesProps {
  challenges?: string[];
}

export const TopBusinessChallenges = ({ challenges }: TopBusinessChallengesProps) => {
  const { t } = useTranslation('analysis');

  if (!challenges?.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.topBusinessChallenges.topBusinessChallenges')}
        subtitle={t('analysisResult.topBusinessChallenges.theThreeConstraintsOnProfitableGrowth')}
        subtitleTone="meta"
      />
      <div className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-3">
        {challenges.map((challenge, index) => (
          <div
            key={`${challenge}-${index}`}
            className="flex flex-col items-center gap-1 rounded-xl border border-border-light p-xl text-center"
          >
            {/* Orange has no semantic token in the library, so the chip names the palette
                step directly; the design calls for it here and yellow elsewhere. */}
            <span className="mb-2 inline-flex items-center rounded-full bg-orange-100 px-3 py-0.5 text-label-md font-medium whitespace-nowrap text-orange-800">
              {t('analysisResult.topBusinessChallenges.challengeNumber', {
                challengeNumber: index + 1,
              })}
            </span>
            <AnalysisMarkdown text={challenge} className="text-body-md text-foreground-alt" />
          </div>
        ))}
      </div>
    </div>
  );
};
